import React, {useMemo, useRef} from 'react';
import styles from './ConfirmDialog.module.css';
import useFocusTrap from '../../app-shell/useFocusTrap';

/**
 * A destructive-action confirmation. role="alertdialog", focus starts on
 * Cancel (not the destructive button), Escape and the scrim both cancel.
 */
const ConfirmDialog = ({open, title, body, confirmLabel = 'Delete', onConfirm, onCancel, busy, error}) => {
    const dialogRef = useRef(null);
    const cancelRef = useRef(null);
    const initialFocusRefs = useMemo(() => [cancelRef], []);

    useFocusTrap(open, dialogRef, initialFocusRefs);

    if (!open) return null;

    return (
        <div className={styles.scrim} onClick={onCancel}>
            <div
                ref={dialogRef}
                role="alertdialog"
                aria-modal="true"
                aria-labelledby="confirm-dialog-title"
                className={styles.dialog}
                onClick={(e) => e.stopPropagation()}
                onKeyDown={(e) => { if (e.key === 'Escape') onCancel(); }}
            >
                <h3 id="confirm-dialog-title" className={styles.title}>{title}</h3>
                <p className={styles.body}>{body}</p>
                {error && <p role="alert" className={styles.error}>{error}</p>}
                <div className={styles.actions}>
                    <button ref={cancelRef} type="button" className={styles.cancelButton} onClick={onCancel}>
                        Cancel
                    </button>
                    <button type="button" className={styles.confirmButton} onClick={onConfirm} disabled={busy}>
                        {busy ? 'Deleting…' : confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;
